import { createAction, props } from '@ngrx/store';
import { Token } from '@warema/shared/authentication/models';
import { User } from '@warema/shared/models';

// ------------------------------------------------------------------------------------------
// G E N E R A L
// ------------------------------------------------------------------------------------------
export const setTokenAction = createAction('[AUTH] Set Token', props<{ token: Token | null }>());
export const setUserUnauthenticatedAction = createAction('[AUTH] Set User Unauthenticated');
export const setFinishedInitializingAction = createAction('[AUTH] Set Finished Initializing');

// ------------------------------------------------------------------------------------------
// U S E R   I N F O   L O A D I N G
// ------------------------------------------------------------------------------------------
export const loadUserAction = createAction('[AUTH] Load User');
export const loadUserSuccessAction = createAction('[AUTH] Load User Success', props<{ user: User }>());
export const loadUserErrorAction = createAction('[AUTH] Load User Error', props<{ error: string }>());
